import GET_ARTICLES from "../plugins/getArticles";
import GET_FRUITS from "../plugins/getFruits";

// import 'slick-carousel'
export default function HOME() {

  $(() => {
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'news':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr:{
            class: 'button button-border-bottom-primary c-btn-icon-right visible-xsmall'
          }
        },
        title:{
          html: '<small>NEWS</small><span><img src="/asset/img/top/top_news_title@2x.png" alt="お知らせ" width="140" loading="lazy"></span>' // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          $this
            .append( $date )
            .append( $title.append($catetitle,$new) )
            .append( $catch )
            .append( $body );
          // $date.insertAfter( $catetitle );
          const $item_body =$('<div />',{
            class: 'p-newsBlock__body'
          })
          $this.wrapInner( $item_body )
          $this.find('.thum_img').prependTo( $this )
          $this.find('table:eq(0)').remove()
        },
        cb($block,opt){
          const $btn = $(`<a />`,{
            class: 'button button-border-bottom-primary c-btn-icon-right hidden-xsmall',
            href: '/news/'
          }).text('VIEW ALL')
          $block.find('.contents').prepend( $btn )
        }
      }
    }));

    GET_FRUITS()
  
    window.load['mainvisual'].done(()=>{
      GET_ARTICLES('[data-name="topNews"]',{
        makeItem(item,opt){
          const newtxt = (item.is_new)? '<span class="new">NEW</span>':'';
          return $(`
            <p class="${opt.prefix}item">
              <span class="date">${item.date}</span>
              <a class="title" href="${item.href}">${item.title.str_truncate(33)}</a>
              <a class="cate" href="${item.category.href}">［${item.category.name}］</a>
              ${newtxt}
            </p>
          `)[0]
        }
      })

      // SP時のメインイメージ高さ
      let resizeTimer
      let currentHeight
      const $mainimg = document.querySelector('.p-mainvisual__img')
      const mainimgHeight = () => {
        clearTimeout(resizeTimer)
        if( window.innerWidth > 767 ) return
        if( Math.abs(window.innerHeight - currentHeight) < 80 ) return
        resizeTimer = setTimeout(() => {
          let h = window.innerHeight - 63 - 20;
          $mainimg.style.height = `${h}px`
          currentHeight = window.innerHeight
        }, 200);
      }
      mainimgHeight()
      window.addEventListener('resize',mainimgHeight)
    })
  });

}